import { PlusCircleIcon, MinusCircleIcon } from '@heroicons/react/24/outline'

export default function PlusMinusButtonChanger({ setIndex, label, value, handleSubtractFunction, handleAddFunction, lateral, setUnit }) {
    return (
        <div className="flex items-center text-center gap-x-1">
            {/*<p>{label}</p>*/}

            <button onClick={() => handleSubtractFunction(setIndex)}>
                <MinusCircleIcon className="h-4 text-stone-500 hover:text-stone-400" />
            </button>

            <p>
                {value} {setUnit === 'seconds' ? 's' : ''} {lateral === 'unilateral' ? ' / s' : ''}
            </p>

            <button onClick={() => handleAddFunction(setIndex)}>
                <PlusCircleIcon className="h-4 text-stone-500 hover:text-stone-400" />
            </button>
        </div>
    )
}
